import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { MedicalNoteResponse, MedicalNoteType } from './medicalNotes';

export type CommunicationNoteResponse = MedicalNoteResponse<MedicalNoteType.communicationNote>;

export const createCommunicationNote = async (patientId: string, createDate: string) =>
  restClient.request<CommunicationNoteResponse>(`/api/v1/patient/${patientId}/medical_notes/communication_note`, {
    method: 'POST',
    data: {
      communication_note_form: {
        communication_date: createDate
      },
      risk_assessment_form: {},
    }
  });

export const createCommunicationNoteForStudent = async (studentId: string, createDate: string) =>
  restClient.request<CommunicationNoteResponse>(`/api/v1/higher_ed/patient/${studentId}/medical_notes/communication_note`, {
    method: 'POST',
    data: {
      communication_note_form: {
        communication_date: createDate
      },
      risk_assessment_form: {},
    }
  });

export type UpdateCommNoteInput = {
  cptCodeIds?: string[];
  diagnosisIds?: string[];
  communicationNoteForm: Record<string, unknown>;
  riskAssessmentForm: Record<string, unknown>;
  isSubmitted?: boolean;
};

export const updateCommunicationNote = async (noteId: string, data: UpdateCommNoteInput) =>
  restClient.request<CommunicationNoteResponse>(`/api/v1/medical_notes/communication_note/${noteId}`, {
    method: 'PATCH',
    data: snakecaseKeys(data)
  });

export const updateCommunicationNoteForStudent = async (noteId: string, data: UpdateCommNoteInput) =>
  restClient.request<CommunicationNoteResponse>(`/api/v1/higher_ed/medical_notes/communication_note/${noteId}`, {
    method: 'PATCH',
    data: snakecaseKeys(data)
  });

export const deleteCommunicationNote = async (noteId: string) =>
  restClient.request<CommunicationNoteResponse>(`/api/v1/medical_notes/communication_note/${noteId}`, {
    method: 'DELETE',
  });

export const getCommunicationNote = async (noteId: string) =>
  restClient.request<CommunicationNoteResponse>(`/api/v1/medical_notes/${noteId}`);
